<template>
    <div id="app">
        <transition name="fade">
            <router-view/>
        </transition>
    </div>
</template>

<script>
    export default {
        name: 'App'
    }
</script>

<style>

    #app {
        font-family: 'Quicksand', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        background-image: url(./assets/background.jpg);
        background-position: top center;
        background-size: cover;
        height: 100%;
    }

    body, html {
        height: 100%;
        margin: 0;
        padding: 0;
    }

    html {
        font-size: 23px;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue